import _ from 'lodash';
import React, { Component } from 'react';
import { Grid, Row, Col, Media, ProgressBar } from 'react-bootstrap';
import Offer from '../common/Offer';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import './Project.css';

class Project extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isFavourite: false
        };
    };

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.fetchScreenProject(id);
        if (this.props.user) {
            this.props.retrieveFavourite();
        }
        this.props.fetchUser();
        this.setState({isFavourite: this.props.isFavourite})
    }

    addToFavourites() {
       var isFavourite = !this.state.isFavourite;
        this.setState({isFavourite: isFavourite})
        if (!isFavourite) {
            this.props.deleteFavourite({projectId: this.props.project.projectId, isFavourite: isFavourite });
        } else {
            this.props.addFavourite({projectId: this.props.project.projectId, isFavourite: isFavourite });
        }
    }

    renderFavourites() {
        var isFavourite = this.state.isFavourite;

        // Only enable click events if user is logged in
        if (!this.props.user) {
            return (
                <img className="project-card-fav-sm-logo responsive-img" src="/images/fav-inactive.png" alt="" />
            );
        }

        if (!isFavourite) {
            return (
                // <Glyphicon glyph="glyphicon glyphicon-heart-empty" onClick={this.addToFavourites.bind(this)} />
                <img className="project-card-fav-sm-logo responsive-img" src="/images/fav-inactive.png" onClick={this.addToFavourites.bind(this)} alt="" />
            );
        } else {
            return (
                // <Glyphicon glyph="glyphicon glyphicon-heart" onClick={this.addToFavourites.bind(this)} />
                <img className="project-card-fav-sm-logo responsive-img" src="/images/fav-active.png" onClick={this.addToFavourites.bind(this)} alt="" />
            );
        }
    }

    renderImpact(projectId, type, impactTargets, volunteer) {
        switch (type) {
            case 'volunteer':
                return (
                    <Media.Body align="bottom">
                        <p>
                            {/* {volunteer.hours} hours over {volunteer.period} {volunteer.units} */}
                        </p>
                    </Media.Body>
                );
            default:
                const donateGoal = impactTargets.donateGoal / 100;
                return (
                    <Media.Body align="bottom">
                        <p>
                            {impactTargets.donateCurrentPct.toFixed(0) + '%'} of ${donateGoal.toLocaleString('en')} funded
                            <br />
                            {/* $700 = 1 well */}
                        </p>
                        <ProgressBar bsStyle="warning" now={impactTargets.donateCurrentPct} className="project-home-card-progress" />
                        <p>
                            <br />
                            funders: {impactTargets.donorCount.toFixed(0)}
                        </p>
                    </Media.Body>
                );
        }
    }

    renderOffers(auth, project, offers) {
        if (!offers) {
            return (
                <p></p>
            );
        }
        if (offers.length <= 0) {
            return (
                <p></p>
            );
        }
        switch (project.type) {
            default:
                return (
                    <div>
                        {offers.map((offer) => (
                            <div key={offer.offerId}>
                                <Offer offer={offer} project={project} auth={auth} />
                            </div>
                        ))}
                    </div>
                );
        }
    }

    render () {
        const { project, auth } = this.props;

        if (!project) {
            return (
                <h4>Loading...</h4>
            );
        }

        const {
            _id,
            projectId,
            type,
            title,
            imageHero,
            imageProfile,
            longDescription,
            impactDescLong,
            impactDescShort,
            charity,
            categories,
            impactTargets,
            volunteer,
            offers
        } = this.props.project;

        const style = {
            imageHero: {
                backgroundImage: `url(${imageHero})`,
                backgroundPosition: 'center center no-repeat',
                backgroundSize: 'cover',
                minHeight: 450,
                maxHeight: 450
            },
            imageProfile: {
                backgroundImage: `url(${imageProfile})`,
                backgroundPosition: 'center center no-repeat',
                backgroundSize: 'cover',
                width: '100%',
                height: '250px'
            }
        };

        return (
            <div>
                <Header auth={auth} />
                <div style={style.imageHero}></div>
                <Grid bsClass="project-body">
                    <Row className="show-grid">
                        <Col xs={12} sm={12} md={7}>
                            <div className="project-card-body">
                                <h3>{title}</h3>
                            </div>
                            <div className="project-card-body">
                                <div className="tikki-filter" style={style.imageProfile}></div>
                            </div>
                            <div className="project-card-body">
                                <h3>Project Details</h3>
                            </div>
                            <div className="project-card-body">
                                {longDescription}
                            </div>
                            <div className="project-card-body">
                                <h3>The Impact</h3>
                            </div>
                            <div className="project-card-body">
                                {impactDescLong}
                            </div>
                            <div className="project-card-body">
                                {/* this is intentionally blank */}
                                <h3></h3>
                            </div>
                            <div className="project-card-body">
                                <span className="tikki-orange">Immediate and Direct Impact: {impactDescShort}</span>
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={5}>
                            <div className="project-card-icons-container">
                                    {categories.map((category, index) => (
                                        <img
                                            key={category.categoryId}
                                            className="project-card-sm-logo responsive-img"
                                            src={category.imageLogo}
                                            alt=""
                                        />
                                    ))}
                                    {this.renderFavourites()}
                            </div>
                            <Media>
                                <Media.Left align="bottom">
                                    <img
                                        className="tikki-card-xl-logo responsive-img"
                                        src={charity[0].imageLogo}
                                        alt=""
                                    />
                                </Media.Left>
                                <Media.Body>
                                    <br />
                                    <Media.Heading>{charity[0].title}</Media.Heading>
                                    <br />
                                    <Link to={`/charities/${charity[0].org}`}>
                                    See Profile
                                    </Link>
                                </Media.Body>
                            </Media>
                            <Media>
                                {this.renderImpact(projectId, type, impactTargets, volunteer)}
                            </Media>
                            <Media>
                                <Media.Body align="bottom">
                                    {this.renderOffers(auth, project, offers)}
                                </Media.Body>
                            </Media>
                        </Col>
                    </Row>
                    <Row className="show-grid">
                        <Col xs={12} sm={12} md={7}>
                            <div className="project-card-body">
                                <h3>About {charity[0].title}</h3>
                            </div>
                            <div className="project-card-body">
                                {charity[0].longDescription}
                            </div>
                        </Col>
                    </Row>
                </Grid>
                <Footer />
            </div>
        );
    };
};

function mapStateToProps({ projects, payments, favourites, isFavourite, user }, ownProps) {
    isFavourite = false;
    // if projectId is in the fav results, then fav is true
    if (_.hasIn(favourites, ownProps.match.params.id)) {
        isFavourite = true;
    }
    // if user is not logged in then fav is false
    if (!user) {
        isFavourite = false;
    }

    return {
        project: projects[ownProps.match.params.id],
        payments,
        favourites,
        isFavourite: isFavourite,
        user
    };
}

export default connect(mapStateToProps, actions)(Project);



// WEBPACK FOOTER //
// ./src/components/Projects/Project.js